import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import useAxios from "../useAxios";
import "../Competitions/CompetitionsList.css";

const UserCompetitions = ({ logout }) => {
  const [axios] = useAxios(true, logout);
  const [competitions, setCompetitions] = useState(null);

  useEffect(() => {
    axios.get("competitions", setCompetitions);
  }, []);

  if (competitions === null) {
    return <h1>Loading...</h1>;
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadge = (status) => {
    const badges = {
      0: { text: 'Pending', class: 'status-pending' },
      1: { text: 'Started', class: 'status-started' },
      2: { text: 'Finished', class: 'status-finished' }
    };
    
    const badge = badges[status] || { text: 'Unknown', class: 'status-unknown' };
    return <span className={`status-badge ${badge.class}`}>{badge.text}</span>;
  };

  return (
    <div className="competitions-container">
      <h2>Competitions</h2>
      
      <div className="competitions-grid">
        {competitions.map((competition) => (
          <div key={competition.id} className="competition-card">
            <div className="competition-header">
              <h3>{competition.name}</h3>
              {getStatusBadge(competition.status)}
            </div>
            
            <div className="competition-details">
              <div className="detail-row">
                <span className="label">Type:</span>
                <span className="value">{competition.type.name}</span>
              </div>
              
              <div className="detail-row">
                <span className="label">Date:</span>
                <span className="value">{formatDate(competition.dateTime)}</span>
              </div>
              
              {competition.sameDay && (
                <div className="detail-row">
                  <span className="label">Format:</span>
                  <span className="value">Same Day Competition</span>
                </div>
              )}
              
              <div className="detail-row">
                <span className="label">Players:</span>
                <span className="value">{competition.playerCount || 0}</span>
              </div>
            </div>
            
            <div className="competition-actions">
              {competition.status === 0 && (
                <Link 
                  to={`/user/competitions/${competition.id}`} 
                  className="btn-primary"
                >
                  Join/View
                </Link>
              )}
              
              {competition.status === 1 && (
                <Link 
                  to={`/user/competitions/${competition.id}/draw`} 
                  className="btn-secondary"
                >
                  View Draw
                </Link>
              )}
              
              {competition.status === 2 && (
                <Link 
                  to={`/user/competitions/${competition.id}/draw`} 
                  className="btn-tertiary"
                >
                  View Results
                </Link>
              )}
            </div>
          </div>
        ))}
      </div>
      
      {competitions.length === 0 && (
        <div className="empty-state">
          <h3>No competitions available</h3>
          <p>Check back later for new competitions to join!</p>
        </div>
      )}
    </div>
  );
};

export default UserCompetitions;